// extracted by mini-css-extract-plugin
export default {"inputImg_1":"BlogPage_inputImg_1__Inzfm","inputImg_2":"BlogPage_inputImg_2__e+NIc","inputImg_3":"BlogPage_inputImg_3__OvfIq","inputImg_4":"BlogPage_inputImg_4__LBevx"};